import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createReservation = async (payload) => {
  const { data } = await axios.post(`${API}/reservations`, payload);
  return data;
};

export const listReservations = async (token) => {
  const { data } = await axios.get(`${API}/reservations`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

// Compute next N Thursday dates (ISO yyyy-mm-dd)
export const getNextThursdays = (count = 6) => {
  const out = [];
  const d = new Date();
  // Thursday = 4
  const dayDiff = (4 - d.getDay() + 7) % 7;
  d.setDate(d.getDate() + (dayDiff === 0 ? 0 : dayDiff));
  for (let i = 0; i < count; i++) {
    const dd = new Date(d);
    dd.setDate(dd.getDate() + i * 7);
    const iso = dd.toISOString().slice(0, 10);
    const label = dd.toLocaleDateString("it-IT", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
    out.push({ value: iso, label: label.charAt(0).toUpperCase() + label.slice(1) });
  }
  return out;
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/vkoidm61_provalo_oro_satinato_black_1080.png",
  heroVideo: "https://customer-assets.emergentagent.com/job_5a36ffa4-de75-4198-8000-9a7b3bfa4a74/artifacts/6dxfoaqf_video%20GOURMET-NAIF%2022S.mp4",
  attimosphereVideo: "https://customer-assets.emergentagent.com/job_5a36ffa4-de75-4198-8000-9a7b3bfa4a74/artifacts/lvbna6dw_attimosphera%20video.mp4",
  extraVideo: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/kh3q9ay4_video%201.mp4",

  attimosphere1: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/h3xe0nqf_attimosphera1.jpeg",
  attimosphere4: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/bgrh26xn_attimosphera4.jpeg",

  picanhaSmoke: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/vuwjhzy4_Picana%20e%20grasso%20di%20Pata%20Negra.jpg",
  picanhaClose: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/c526oux8_DSC05076%20%282025-10-22T16_52_39.758%29.jpg",
  picanhaCheese: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/ng9cq6ah_Picana%20e%20grasso%20di%20Pata%20Negra1.jpg",

  filoFumo: "https://customer-assets.emergentagent.com/job_5a36ffa4-de75-4198-8000-9a7b3bfa4a74/artifacts/2iao8cee_FiloFumo5.jpg",
  filoFumoCheese: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/o0wf1mbw_FiloFumo3.jpg",

  whiskyBg: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/gtdmnq3t_wischy4.jpg",

  salsiccia1: "https://customer-assets.emergentagent.com/job_5a36ffa4-de75-4198-8000-9a7b3bfa4a74/artifacts/a84bfhmr_salsiccia%20messinese1.jpg",
  salsiccia2: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/lpyv35aw_salsiccia%20messinese2.jpg",
  salsicciaClose: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/d4qdy7f5_salsiccia%20messinese1.jpg",

  ingresso: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/jmeyumd0_ingresso%20Provalo.jpg",
  terrazza: "https://customer-assets.emergentagent.com/job_lab-spiedi/artifacts/ksmkf6mu_Immagine%20WhatsApp%202025-08-28%20ore%2020.13.30_24dfb40d.jpg",
};

export const RESERVE_URL = "https://pnssm.pro/5sq02s5";
export const MENU_URL = "https://pnssm.pro/2ef0e7n";
